import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useAuthors() {
  const query = useQuery({
    queryKey: ['authors'],
    queryFn: () => api.getAuthors(),
  });

  return {
    authors: query.data ?? [],
    loading: query.isLoading,
    error: query.error,
  };
}
